export default {
      id: "naver-shaded-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#naver-shaded",
      toString: function () {
        return this.url;
      }
    }